import script from "./SelectRelateCoursewareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectRelateCoursewareModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectRelateCoursewareModal.vue?vue&type=style&index=0&id=5f29484e&scoped=true&lang=less"
script.__scopeId = "data-v-5f29484e"

export default script